/* istanbul ignore file */
const renameKeyInObject = (o, oldKey, newKey) => {
  const newObject = {}
  delete Object.assign(newObject, o, { [newKey]: o[oldKey] })[oldKey]
  return newObject
}

/**
 * Wrap link handler creation and instance to clean up iframe via destroy() method
 */
export const createPlaid = (options) => {
  const state = {
    onExitCallback: null,
    open: false,
    plaid: null
  }

  // If Plaid is not available, throw an Error
  if (typeof window === 'undefined' || !window.Plaid) {
    throw new Error('Plaid not loaded')
  }

  const config = renameKeyInObject(
    options,
    'publicKey',
    'key'
  )

  state.plaid = window.Plaid.create({
    ...config,
    onExit: (...params) => {
      config.onExit && config.onExit(...params)
      state.onExitCallback && state.onExitCallback()
    }
  })

  const open = () => {
    if (!state.plaid) {
      return
    }
    state.open = true
    state.onExitCallback = null
    state.plaid.open()
  }

  const exit = (exitOptions, callback) => {
    if (!state.open || !state.plaid) {
      callback && callback()
      return
    }
    state.onExitCallback = callback
    state.plaid.exit(exitOptions)
    if (exitOptions && exitOptions.force) {
      state.open = false
    }
  }

  const destroy = () => {
    if (!state.plaid) {
      return
    }

    state.plaid.destroy()
    state.plaid = null
  }

  return {
    destroy,
    exit,
    open
  }
}
